import React, { useState, useCallback, useEffect } from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import { useMediaQuery } from 'react-responsive';
import BreadCrumb from '../utility/breadCrumb';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import LessonControlPanel from '../components/LessonControlPanel';
import LessonCard from '../components/LessonCard'; // Assuming a Card component
import allLessons from '../data/lessons'; // flat data file

const Lessons = () => {
  const [filteredLessons, setFilteredLessons] = useState(allLessons.lessons);
  const [displayedLessons, setDisplayedLessons] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const lessonsPerPage = 12;
  const isMobile = useMediaQuery({ maxWidth: 577 });

  const handleFilterChange = useCallback((filters) => {
    let tempLessons = [...allLessons.lessons];

    if (filters.searchTerm) {
      const searchTerm = filters.searchTerm.toLowerCase();
      tempLessons = tempLessons.filter(lesson =>
        lesson.title.toLowerCase().includes(searchTerm) ||
        lesson.description.toLowerCase().includes(searchTerm) ||
        (lesson.tags && lesson.tags.some(tag => tag.toLowerCase().includes(searchTerm)))
      );
    }

    if (filters.category !== 'All') {
      tempLessons = tempLessons.filter(lesson => lesson.category === filters.category);
    }

    if (filters.difficulty !== 'All') {
      tempLessons = tempLessons.filter(lesson => lesson.difficulty === filters.difficulty);
    }

    setFilteredLessons(tempLessons);
    setCurrentPage(1); // Reset to the first page on filter change
  }, []);

  useEffect(() => {
    const lessonsToShow = isMobile
      ? filteredLessons.slice(0, currentPage * lessonsPerPage)
      : filteredLessons.slice((currentPage - 1) * lessonsPerPage, currentPage * lessonsPerPage);
    setDisplayedLessons(lessonsToShow);
  }, [currentPage, filteredLessons, isMobile]);

  const handleScroll = useCallback(() => {
    // On mobile, if the user is near the bottom of the page, and there are more lessons to load, increment the page.
    if (isMobile && displayedLessons.length < filteredLessons.length) {
        const nearBottom = window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 150;
        if (nearBottom) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    }
}, [isMobile, displayedLessons.length, filteredLessons.length]);

useEffect(() => {
    if (isMobile) {
        window.addEventListener('scroll', handleScroll);
    } else {
        window.removeEventListener('scroll', handleScroll);
    }

    return () => window.removeEventListener('scroll', handleScroll);
}, [isMobile, handleScroll]);


  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="lessons-page">
      <h1>Guitar Lessons & Exercises</h1>
      <LessonControlPanel
        lessons={allLessons.lessons}
        onFilterChange={handleFilterChange}
      />
      <div className="lesson-grid">
        {displayedLessons.length > 0 ? (
          displayedLessons.map((lesson, index) => (
            <LessonCard key={`${index}-${lesson.id}`} lesson={lesson} />
          ))
        ) : (
          <p>No lessons match your criteria.</p>
        )}
      </div>
      <Pagination
        lessonsPerPage={lessonsPerPage}
        totalLessons={filteredLessons.length}
        paginate={paginate}
        currentPage={currentPage}
      />
    </div>
  );
};

const Pagination = ({ lessonsPerPage, totalLessons, paginate, currentPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalLessons / lessonsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav>
      <ul className='pagination'>
        {pageNumbers.map(number => (
          <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
            <button onClick={() => paginate(number)} className='page-link'>
              {number}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Lessons;
